var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.envpagedata),function(envitem){return _c('NavEnvBlock',{attrs:{"envitem":envitem},nativeOn:{"click":function($event){return _vm.selectEnvirements(envitem.id)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }